// extracted by mini-css-extract-plugin
export default {"storyDetailListWrapper":"c-r_gl","storyDetailListWrapper__title":"c-r_gm","storyDetailListWrapper__timeline":"c-r_gn","storyDetailListWrapper__list":"c-r_go"};